import { render, staticRenderFns } from "./DrawableCanvas.vue?vue&type=template&id=f6a85f96&scoped=true&"
import script from "./DrawableCanvas.vue?vue&type=script&lang=ts&"
export * from "./DrawableCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./DrawableCanvas.vue?vue&type=style&index=0&id=f6a85f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a85f96",
  null
  
)

export default component.exports